document.addEventListener('DOMContentLoaded', function() {
    var playBtns = document.querySelectorAll('.play-btn');
    playBtns.forEach(function(playBtn) {
      playBtn.addEventListener('click', function() {
        // 找到当前按钮所在的视频容器
        var container = playBtn.closest('.pdp-video__headline-video');
        if (!container) return;
  
        var poster = container.querySelector('.poster');
        var video = container.querySelector('video');
  
        playBtn.style.display = 'none';
        if (poster) poster.style.display = 'none';
  
        if (video) {
          video.play();
          // 播放结束后恢复按钮和海报
          video.addEventListener('ended', function onEnded() {
            if (poster) poster.style.display = '';
            playBtn.style.display = '';
            video.currentTime = 0;
            video.pause();
            // 只绑定一次
            video.removeEventListener('ended', onEnded);
          });
        }
      });
    });
  });